"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  MonitorRefresh: ['monitor-refresh', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.989,11.939a.25.25,0,0,0-.163-.439H2.5A.5.5,0,0,1,2,11V2.5A.5.5,0,0,1,2.5,2h13a.5.5,0,0,1,.5.5V9.808a.25.25,0,0,0,.28.248A7.284,7.284,0,0,1,17.147,10c.2,0,.391.009.583.023a.249.249,0,0,0,.19-.065A.252.252,0,0,0,18,9.774V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V12.5a2,2,0,0,0,2,2H7.5A.5.5,0,0,1,8,15v.5a.5.5,0,0,1-.5.5H5a1,1,0,0,0,0,2H9.147a.125.125,0,0,0,.125-.125A7.849,7.849,0,0,1,11.989,11.939Z', 'M23.692,11.56a.5.5,0,0,0-.545.108l-1.3,1.3a.251.251,0,0,1-.348.005,6.315,6.315,0,0,0-4.354-1.721A6.375,6.375,0,1,0,22.13,21.6a1,1,0,0,0-1.563-1.248,4.376,4.376,0,1,1-.5-5.982.25.25,0,0,1,.009.362L18.69,16.125a.5.5,0,0,0,.353.854H23.5a.5.5,0,0,0,.5-.5V12.022A.5.5,0,0,0,23.692,11.56Z']],
  MonitorLock: ['monitor-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.5,11.86a.25.25,0,0,0-.225-.359H2.5A.5.5,0,0,1,2,11V2.5A.5.5,0,0,1,2.5,2h13a.5.5,0,0,1,.5.5V9.548a.249.249,0,0,0,.383.211,4.893,4.893,0,0,1,1.427-.614A.25.25,0,0,0,18,8.9V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V12.5a2,2,0,0,0,2,2H7.5A.5.5,0,0,1,8,15v.5a.5.5,0,0,1-.5.5H5a1,1,0,0,0,0,2h7.25a.25.25,0,0,0,.25-.25v-1.5a.25.25,0,0,0-.25-.25H10.5a.5.5,0,0,1-.5-.5V15a.5.5,0,0,1,.5-.5h2.6a.247.247,0,0,0,.156-.055,2,2,0,0,1,.678-.357A.092.092,0,0,0,14,14,4.87,4.87,0,0,1,14.5,11.86Z', 'M22.714,15.516a.25.25,0,0,1-.214-.248V14.251a3.5,3.5,0,1,0-7,0v1.017a.25.25,0,0,1-.214.248A1.5,1.5,0,0,0,14,17v5.5A1.5,1.5,0,0,0,15.5,24h7A1.5,1.5,0,0,0,24,22.5V17A1.5,1.5,0,0,0,22.714,15.516ZM19,21.251a1,1,0,1,1,1-1A1,1,0,0,1,19,21.251Zm1.5-6a.25.25,0,0,1-.25.25h-2.5a.25.25,0,0,1-.25-.25v-1a1.5,1.5,0,1,1,3,0Z']],
  MonitorBug: ['monitor-bug', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.85,16.012A.055.055,0,0,0,11.815,16H10.5a.5.5,0,0,1-.5-.5V15a.5.5,0,0,1,.5-.5h.25a.249.249,0,0,0,.25-.25,2.25,2.25,0,0,1,3.65-1.76l.881.7a.252.252,0,0,0,.267.029,4.406,4.406,0,0,1,1.952-.469h.02a.219.219,0,0,0,.227-.2.463.463,0,0,0,0-.054V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V12.5a2,2,0,0,0,2,2H7.5A.5.5,0,0,1,8,15v.5a.5.5,0,0,1-.5.5H5a1,1,0,0,0,0,2h5.1a.25.25,0,0,0,.216-.124,2.239,2.239,0,0,1,1.937-1.125.185.185,0,0,0,.115-.329ZM2.5,11.5A.5.5,0,0,1,2,11V2.5A.5.5,0,0,1,2.5,2h13a.5.5,0,0,1,.5.5V11a.5.5,0,0,1-.5.5Z', 'M24,19a.75.75,0,0,0-.75-.75H21a.25.25,0,0,1-.25-.25v-.75a2.706,2.706,0,0,0-.075-.608.25.25,0,0,1,.089-.251l1.953-1.554a.75.75,0,1,0-.934-1.174L20.07,15.027a.25.25,0,0,1-.323-.01,2.987,2.987,0,0,0-3.995,0,.248.248,0,0,1-.322.01l-1.713-1.363a.75.75,0,0,0-.934,1.174l1.953,1.554a.249.249,0,0,1,.089.251,2.706,2.706,0,0,0-.075.608V18a.25.25,0,0,1-.25.25H12.25a.75.75,0,0,0,0,1.5H14.5a.25.25,0,0,1,.25.25v.25a2.713,2.713,0,0,0,.075.608.251.251,0,0,1-.088.251l-1.954,1.554a.75.75,0,0,0,.934,1.174l1.714-1.363a.249.249,0,0,1,.322.01,2.986,2.986,0,0,0,3.994,0,.249.249,0,0,1,.322-.01l1.714,1.363a.75.75,0,1,0,.934-1.174L20.763,21.11a.25.25,0,0,1-.088-.252,2.7,2.7,0,0,0,.075-.607V20a.25.25,0,0,1,.25-.25h2.25A.75.75,0,0,0,24,19Z']],
  MonitorApprove: ['monitor-approve', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.779,11.925A.249.249,0,0,0,11.6,11.5H2.5A.5.5,0,0,1,2,11V2.5A.5.5,0,0,1,2.5,2h13a.5.5,0,0,1,.5.5V9.35a.249.249,0,0,0,.289.247A7.8,7.8,0,0,1,17.5,9.5c.079,0,.157,0,.235.008A.251.251,0,0,0,18,9.259V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V12.5a2,2,0,0,0,2,2H7.5A.5.5,0,0,1,8,15v.5a.5.5,0,0,1-.5.5H5a1,1,0,0,0,0,2H9.258a.25.25,0,0,0,.182-.079.247.247,0,0,0,.068-.186c0-.078-.008-.156-.008-.235A7.961,7.961,0,0,1,11.779,11.925Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm3.474,5.354-2.9,3.874a1.749,1.749,0,0,1-1.28.7c-.043,0-.087,0-.13,0a1.736,1.736,0,0,1-1.231-.516l-1.5-1.5A1,1,0,1,1,15.344,17.5L16.438,18.6a.251.251,0,0,0,.377-.027l2.559-3.412a1,1,0,0,1,1.6,1.2Z']],
  MonitorEdit: ['monitor-edit', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.247,17.92l1.371-1.5A.25.25,0,0,0,12.434,16H10.5a.5.5,0,0,1-.5-.5V15a.5.5,0,0,1,.5-.5h4.068a.251.251,0,0,0,.177-.073l3.182-3.182A.249.249,0,0,0,18,11.069V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V12.5a2,2,0,0,0,2,2H7.5A.5.5,0,0,1,8,15v.5a.5.5,0,0,1-.5.5H5a1,1,0,0,0,0,2h6.061A.248.248,0,0,0,11.247,17.92ZM2.5,11.5A.5.5,0,0,1,2,11V2.5A.5.5,0,0,1,2.5,2h13a.5.5,0,0,1,.5.5V11a.5.5,0,0,1-.5.5Z', 'M12.74,20.046a.5.5,0,0,0-.835.216l-.885,3.1a.5.5,0,0,0,.618.619l3.1-.886a.5.5,0,0,0,.217-.834Z', 'M18.772,13.229a.5.5,0,0,0-.707,0l-5.011,5.01a.5.5,0,0,0,0,.707l3,3a.5.5,0,0,0,.707,0l5.011-5.01a.5.5,0,0,0,0-.707Z', 'M23.233,11.769a2.658,2.658,0,0,0-3.75.042.5.5,0,0,0-.151.354.507.507,0,0,0,.147.357l3,3a.54.54,0,0,0,.377.123.576.576,0,0,0,.377-.169A2.626,2.626,0,0,0,23.233,11.769Z']],
  MonitorFind: ['monitor-find', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,16.53a6.99,6.99,0,0,1,1.736-4.615.25.25,0,0,0-.188-.414H2.5A.5.5,0,0,1,2,11V2.5A.5.5,0,0,1,2.5,2h13a.5.5,0,0,1,.5.5V9.259a.25.25,0,0,0,.264.25c.088-.005.176-.008.265-.008a6.948,6.948,0,0,1,1.179.1A.25.25,0,0,0,18,9.355V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V12.5a2,2,0,0,0,2,2H7.5A.5.5,0,0,1,8,15v.5a.5.5,0,0,1-.5.5H5a1,1,0,0,0,0,2H9.354a.253.253,0,0,0,.192-.089.25.25,0,0,0,.055-.2A6.927,6.927,0,0,1,9.5,16.53Z', 'M23.707,23.708a1,1,0,0,0,0-1.414l-2.482-2.483a.25.25,0,0,1-.034-.311A5.54,5.54,0,1,0,19.5,21.192a.251.251,0,0,1,.312.033l2.482,2.483a1,1,0,0,0,1.414,0ZM13,16.531a3.53,3.53,0,1,1,3.53,3.53A3.529,3.529,0,0,1,13,16.531Z']],
  MonitorDisable: ['monitor-disable', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.9,12.05a.249.249,0,0,0-.178-.424h-9.1a.5.5,0,0,1-.5-.5v-8.5a.5.5,0,0,1,.5-.5h13a.5.5,0,0,1,.5.5V9.475a.249.249,0,0,0,.289.247,7.8,7.8,0,0,1,1.211-.1c.079,0,.157,0,.235.008a.251.251,0,0,0,.265-.25V2.126a2,2,0,0,0-2-2h-14a2,2,0,0,0-2,2v10.5a2,2,0,0,0,2,2h5.5a.5.5,0,0,1,.5.5v.5a.5.5,0,0,1-.5.5h-2.5a1,1,0,0,0,0,2H9.383a.251.251,0,0,0,.25-.265c0-.078-.008-.156-.008-.235A7.961,7.961,0,0,1,11.9,12.05Z', 'M17.625,11.376a6.25,6.25,0,1,0,6.25,6.25A6.257,6.257,0,0,0,17.625,11.376Zm-3.6,8.289a.248.248,0,0,1-.184-.133,4.16,4.16,0,0,1-.467-1.906,4.255,4.255,0,0,1,4.25-4.25,4.167,4.167,0,0,1,1.907.467.251.251,0,0,1,.063.4L14.242,19.6A.248.248,0,0,1,14.026,19.665Zm3.6,2.211a4.16,4.16,0,0,1-1.906-.467.251.251,0,0,1-.063-.4l5.353-5.352a.25.25,0,0,1,.4.063,4.16,4.16,0,0,1,.467,1.906A4.255,4.255,0,0,1,17.625,21.876Z']],
  MonitorDownload: ['monitor-download', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.177,11.657a.25.25,0,0,0-.232-.156H2.5A.5.5,0,0,1,2,11V2.5A.5.5,0,0,1,2.5,2h13a.5.5,0,0,1,.5.5V9.6a.25.25,0,0,0,.088.19.254.254,0,0,0,.2.057,7.658,7.658,0,0,1,1.21-.1c.079,0,.157,0,.235.007A.248.248,0,0,0,18,9.509V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V12.5a2,2,0,0,0,2,2H7.5A.5.5,0,0,1,8,15v.5a.5.5,0,0,1-.5.5H5a1,1,0,0,0,0,2H9.508a.251.251,0,0,0,.25-.265c0-.078-.008-.156-.008-.235a7.68,7.68,0,0,1,.245-1.9A.229.229,0,0,0,10,15.508V15a.488.488,0,0,1,.268-.436.253.253,0,0,0,.114-.123,7.775,7.775,0,0,1,1.737-2.512A.246.246,0,0,0,12.177,11.657Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm2.391,7.312-2,2.5a.5.5,0,0,1-.782,0l-2-2.5A.5.5,0,0,1,15.5,17.5h.75a.25.25,0,0,0,.25-.25V14.5a1,1,0,1,1,2,0v2.75a.25.25,0,0,0,.25.25h.75a.5.5,0,0,1,.391.812Z']],
  MonitorSubtract: ['monitor-subtract', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.1,11.915a.25.25,0,0,0-.189-.414H2.5A.5.5,0,0,1,2,11V2.5A.5.5,0,0,1,2.5,2h13a.5.5,0,0,1,.5.5V8.847a.25.25,0,0,0,.287.247A8.216,8.216,0,0,1,17.5,9c.079,0,.157,0,.235.008a.254.254,0,0,0,.187-.068A.25.25,0,0,0,18,8.759V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V12.5a2,2,0,0,0,2,2H7.5A.5.5,0,0,1,8,15v.5a.5.5,0,0,1-.5.5H5a1,1,0,0,0,0,2H8.758a.251.251,0,0,0,.25-.265C9,17.658,9,17.58,9,17.5A8.463,8.463,0,0,1,11.1,11.915Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.513,6.513,0,0,0,17.5,11ZM20,18.5H15a1,1,0,0,1,0-2h5a1,1,0,0,1,0,2Z']],
  MonitorSettings: ['monitor-settings', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.757,11.532H2.509a.5.5,0,0,1-.5-.5v-8.5a.5.5,0,0,1,.5-.5h13a.5.5,0,0,1,.5.5V8.4a.25.25,0,0,0,.293.246,8.426,8.426,0,0,1,1.457-.127.25.25,0,0,0,.25-.25V2.032a2,2,0,0,0-2-2h-14a2,2,0,0,0-2,2v10.5a2,2,0,0,0,2,2h5.5a.5.5,0,0,1,.5.5v.5a.5.5,0,0,1-.5.5h-2.5a1,1,0,0,0,0,2H9.046a.252.252,0,0,0,.25-.274c-.023-.244-.037-.49-.037-.741a8.45,8.45,0,0,1,1.7-5.085.25.25,0,0,0-.2-.4Z', 'M16.239 17.001 A1.500 1.500 0 1 0 19.239 17.001 A1.500 1.500 0 1 0 16.239 17.001 Z', 'M22.52,17.314a.464.464,0,0,1,0-.626l.988-1.064a1.783,1.783,0,0,0-1.7-2.953L20.4,13a.455.455,0,0,1-.533-.312L19.439,11.3a1.776,1.776,0,0,0-3.4,0l-.423,1.391a.456.456,0,0,1-.534.312l-1.41-.327a1.783,1.783,0,0,0-1.7,2.953l.987,1.064a.462.462,0,0,1,0,.626l-.987,1.065a1.783,1.783,0,0,0,1.7,2.953l1.412-.327a.454.454,0,0,1,.533.31l.423,1.393a1.776,1.776,0,0,0,3.4,0l.424-1.393a.449.449,0,0,1,.533-.31l1.411.327a1.783,1.783,0,0,0,1.7-2.953ZM17.739,20a3,3,0,1,1,3-3A3,3,0,0,1,17.739,20Z']],
  MonitorStar: ['monitor-star', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.892,17.624A2.716,2.716,0,0,1,12.26,13.5h1.516a.252.252,0,0,0,.23-.151l.648-1.5a.25.25,0,0,0-.23-.349H2.5A.5.5,0,0,1,2,11V2.5A.5.5,0,0,1,2.5,2h13a.5.5,0,0,1,.5.5V9.525a.251.251,0,0,0,.355.228A2.724,2.724,0,0,1,17.5,9.5a1.507,1.507,0,0,1,.214.017.254.254,0,0,0,.2-.058A.251.251,0,0,0,18,9.27V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V12.5a2,2,0,0,0,2,2H7.5A.5.5,0,0,1,8,15v.5a.5.5,0,0,1-.5.5H5a1,1,0,0,0,0,2H9.677a.25.25,0,0,0,.215-.377Z', 'M23.61,17.141,21.4,19.11a.251.251,0,0,0-.063.287l1.227,2.814a1.26,1.26,0,0,1-.32,1.45,1.3,1.3,0,0,1-.86.34,1.4,1.4,0,0,1-.65-.17L17.623,22.08a.249.249,0,0,0-.245,0L14.26,23.831a1.331,1.331,0,0,1-.639.17,1.3,1.3,0,0,1-.861-.34,1.26,1.26,0,0,1-.32-1.45L13.668,19.4a.251.251,0,0,0-.063-.287l-2.194-1.959a1.266,1.266,0,0,1-.321-1.39A1.228,1.228,0,0,1,12.26,15h2.5a.249.249,0,0,0,.229-.151l1.345-3.119A1.311,1.311,0,0,1,17.5,11a1.285,1.285,0,0,1,1.15.7c0,.01.011.02.011.03l1.344,3.119a.252.252,0,0,0,.23.151h2.5a1.24,1.24,0,0,1,1.171.76A1.278,1.278,0,0,1,23.61,17.141Z']],
  MonitorWarning: ['monitor-warning', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.659,17.733l.525-1A.5.5,0,0,0,11.741,16H10.5a.5.5,0,0,1-.5-.5V15a.5.5,0,0,1,.5-.5h2.551a.5.5,0,0,0,.442-.268l1.242-2.366a.25.25,0,0,0-.222-.366H2.5A.5.5,0,0,1,2,11V2.5A.5.5,0,0,1,2.5,2h13a.5.5,0,0,1,.5.5V9.649a.5.5,0,0,0,.645.479A2.919,2.919,0,0,1,17.5,10h0a.5.5,0,0,0,.5-.5V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V12.5a2,2,0,0,0,2,2H7.5A.5.5,0,0,1,8,15v.5a.5.5,0,0,1-.5.5H5a1,1,0,1,0,0,2h6.214A.5.5,0,0,0,11.659,17.733Z', 'M23.837,21.906,18.78,12.272a1.45,1.45,0,0,0-2.562,0l-5.055,9.634a1.429,1.429,0,0,0,.048,1.408A1.456,1.456,0,0,0,12.444,24H22.555a1.456,1.456,0,0,0,1.233-.687A1.431,1.431,0,0,0,23.837,21.906Zm-6.338.345a1,1,0,1,1,1-1A1,1,0,0,1,17.5,22.251Zm1.005-3.5a.75.75,0,0,1-1.5,0v-3a.75.75,0,0,1,1.5,0Z']],
  MonitorUpload: ['monitor-upload', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.18,11.657a.25.25,0,0,0-.232-.156H2.5A.5.5,0,0,1,2,11V2.5A.5.5,0,0,1,2.5,2h13a.5.5,0,0,1,.5.5V9.6a.25.25,0,0,0,.088.19.245.245,0,0,0,.2.057,7.68,7.68,0,0,1,1.211-.1c.079,0,.157,0,.236.007A.248.248,0,0,0,18,9.509V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V12.5a2,2,0,0,0,2,2H7.5A.5.5,0,0,1,8,15v.5a.5.5,0,0,1-.5.5H5a1,1,0,0,0,0,2H9.508a.251.251,0,0,0,.25-.265c0-.078-.008-.156-.008-.235a7.657,7.657,0,0,1,.245-1.9A.254.254,0,0,0,10,15.509V15a.492.492,0,0,1,.269-.437.25.25,0,0,0,.114-.122,7.781,7.781,0,0,1,1.739-2.511A.252.252,0,0,0,12.18,11.657Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.513,6.513,0,0,0,17.5,11Zm2.451,6.216a.5.5,0,0,1-.451.284h-.75a.25.25,0,0,0-.25.25V20.5a1,1,0,1,1-2,0v-2.75a.249.249,0,0,0-.25-.25H15.5a.5.5,0,0,1-.39-.813l2-2.5a.519.519,0,0,1,.781,0l2,2.5A.5.5,0,0,1,19.951,17.217Z']],
  MonitorFlash: ['monitor-flash', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.657,16.335A.25.25,0,0,0,12.421,16H10.5a.5.5,0,0,1-.5-.5V15a.5.5,0,0,1,.5-.5h3.315a.253.253,0,0,0,.2-.094l3.934-4.915A.245.245,0,0,0,18,9.336V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V12.5a2,2,0,0,0,2,2H7.5A.5.5,0,0,1,8,15v.5a.5.5,0,0,1-.5.5H5a1,1,0,0,0,0,2h7.341a.251.251,0,0,0,.2-.1.249.249,0,0,0,.046-.214A2.356,2.356,0,0,1,12.657,16.335ZM2.5,11.5A.5.5,0,0,1,2,11V2.5A.5.5,0,0,1,2.5,2h13a.5.5,0,0,1,.5.5V11a.5.5,0,0,1-.5.5Z', 'M23.792,16.443A.875.875,0,0,0,23.125,15H21.25a.25.25,0,0,1-.25-.25V9.5a.5.5,0,0,0-.89-.313l-5.9,7.37A.875.875,0,0,0,14.875,18H16.75a.25.25,0,0,1,.25.25V23.5a.5.5,0,0,0,.335.471A.474.474,0,0,0,17.5,24a.5.5,0,0,0,.39-.188Z']],
  MonitorHeart: ['monitor-heart', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.03,13.78A5,5,0,0,1,11.6,11.954a.25.25,0,0,0-.145-.453H2.5A.5.5,0,0,1,2,11V2.5A.5.5,0,0,1,2.5,2h13a.5.5,0,0,1,.5.5V11c0,.012,0,.025,0,.037a.25.25,0,0,0,.169.259,4.973,4.973,0,0,1,1.2.584.249.249,0,0,0,.27,0c.077-.047.156-.09.235-.133A.248.248,0,0,0,18,11.534V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V12.5a2,2,0,0,0,2,2H7.5A.5.5,0,0,1,8,15v.5a.5.5,0,0,1-.5.5H5a1,1,0,0,0,0,2H9.548a.249.249,0,0,0,.236-.332A5.013,5.013,0,0,1,10.03,13.78Z', 'M23.628,14.45a3.527,3.527,0,0,0-5.647-.916l-.305.3a.25.25,0,0,1-.353,0l-.3-.3a3.525,3.525,0,0,0-4.993,4.977l5.114,5.335a.5.5,0,0,0,.721,0l5.107-5.327A3.522,3.522,0,0,0,23.628,14.45Z']],
  MonitorQuestion: ['monitor-question', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.627,11.652a.25.25,0,0,0-.23-.151H2.5A.5.5,0,0,1,2,11V2.5A.5.5,0,0,1,2.5,2h13a.5.5,0,0,1,.5.5V9.13a.25.25,0,0,0,.293.246,8.477,8.477,0,0,1,1.452-.125h0A.251.251,0,0,0,18,9V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V12.5a2,2,0,0,0,2,2H7.5A.5.5,0,0,1,8,15v.5a.5.5,0,0,1-.5.5H5a1,1,0,0,0,0,2H9a.25.25,0,0,0,.25-.25,8.451,8.451,0,0,1,2.33-5.828A.251.251,0,0,0,11.627,11.652Z', 'M17.747,11.5A6.25,6.25,0,1,0,24,17.751,6.257,6.257,0,0,0,17.747,11.5Zm0,11.25a1,1,0,1,1,1-1A1,1,0,0,1,17.748,22.751Zm.912-4.164a.25.25,0,0,0-.163.234V19A.75.75,0,1,1,17,19v-.554a1.258,1.258,0,0,1,.988-1.222,1.125,1.125,0,1,0-1.363-1.1.75.75,0,0,1-1.5,0,2.625,2.625,0,1,1,3.538,2.461Z']],
  MonitorAdd: ['monitor-add', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.1,11.915a.25.25,0,0,0-.189-.414H2.5A.5.5,0,0,1,2,11V2.5A.5.5,0,0,1,2.5,2h13a.5.5,0,0,1,.5.5V8.847a.25.25,0,0,0,.287.247A8.226,8.226,0,0,1,17.5,9c.079,0,.157,0,.235.008A.251.251,0,0,0,18,8.759V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V12.5a2,2,0,0,0,2,2H7.5A.5.5,0,0,1,8,15v.5a.5.5,0,0,1-.5.5H5a1,1,0,0,0,0,2H8.759a.25.25,0,0,0,.181-.079.247.247,0,0,0,.068-.186C9,17.658,9,17.58,9,17.5A8.464,8.464,0,0,1,11.1,11.915Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11ZM20,18.5H18.75a.25.25,0,0,0-.25.25V20a1,1,0,1,1-2,0v-1.25a.25.25,0,0,0-.25-.25H15a1,1,0,0,1,0-2h1.25a.25.25,0,0,0,.25-.25V15a1,1,0,1,1,2,0v1.25a.25.25,0,0,0,.25.25H20a1,1,0,0,1,0,2Z']],
  MonitorClock: ['monitor-clock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.381,11.5H2.5A.5.5,0,0,1,2,11V2.5A.5.5,0,0,1,2.5,2h13a.5.5,0,0,1,.5.5v6.06a.5.5,0,0,0,.559.5A7.9,7.9,0,0,1,17.5,9a.5.5,0,0,0,.5-.5V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V12.5a2,2,0,0,0,2,2H7.5A.5.5,0,0,1,8,15v.5a.5.5,0,0,1-.5.5H5a1,1,0,0,0,0,2H8.5a.5.5,0,0,0,.5-.5,8.454,8.454,0,0,1,1.776-5.194.5.5,0,0,0-.395-.806Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm0,11A4.5,4.5,0,1,1,22,17.5,4.505,4.505,0,0,1,17.5,22Z', 'M19.5,16.751h-1a.25.25,0,0,1-.25-.25v-2a.75.75,0,1,0-1.5,0v3a.75.75,0,0,0,.75.75h2a.75.75,0,0,0,0-1.5Z']],
  MonitorRemove: ['monitor-remove', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.78,11.925A.249.249,0,0,0,11.6,11.5H2.5A.5.5,0,0,1,2,11V2.5A.5.5,0,0,1,2.5,2h13a.5.5,0,0,1,.5.5V9.35a.251.251,0,0,0,.289.247A7.8,7.8,0,0,1,17.5,9.5c.079,0,.157,0,.235.007a.248.248,0,0,0,.187-.067A.251.251,0,0,0,18,9.259V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V12.5a2,2,0,0,0,2,2H7.5A.5.5,0,0,1,8,15v.5a.5.5,0,0,1-.5.5H5a1,1,0,0,0,0,2H9.258a.251.251,0,0,0,.25-.265c0-.078-.008-.156-.008-.235A7.958,7.958,0,0,1,11.78,11.925Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.513,6.513,0,0,0,17.5,11Zm1.6,6.677,1.233,1.233a1.027,1.027,0,0,1,.13,1.27,1.738,1.738,0,0,1-.13.15,1.024,1.024,0,0,1-.71.29,1.042,1.042,0,0,1-.71-.29L17.677,19.1a.251.251,0,0,0-.177-.073.255.255,0,0,0-.177.073L16.09,20.331a1.014,1.014,0,0,1-1.42,0,1.738,1.738,0,0,1-.13-.15,1.027,1.027,0,0,1,.13-1.27L15.9,17.677a.249.249,0,0,0,0-.353L14.67,16.091a1.027,1.027,0,0,1-.13-1.27,1.393,1.393,0,0,1,.28-.28,1.027,1.027,0,0,1,1.27.13L17.323,15.9a.251.251,0,0,0,.354,0l1.233-1.233a1.03,1.03,0,0,1,1.27-.13,1.393,1.393,0,0,1,.28.28,1.027,1.027,0,0,1-.13,1.27L19.1,17.324a.249.249,0,0,0,0,.354Z']],
  MonitorSync: ['monitor-sync', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.619,11.656a.25.25,0,0,0-.232-.156H2.5A.5.5,0,0,1,2,11V2.5A.5.5,0,0,1,2.5,2h13a.5.5,0,0,1,.5.5V9.347a.25.25,0,0,0,.287.247A8.226,8.226,0,0,1,17.5,9.5c.079,0,.157,0,.235.008a.25.25,0,0,0,.186-.067A.252.252,0,0,0,18,9.259V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V12.5a2,2,0,0,0,2,2H7.5A.5.5,0,0,1,8,15v.5a.5.5,0,0,1-.5.5H5a1,1,0,0,0,0,2H8.754A.25.25,0,0,0,9,17.757a8.468,8.468,0,0,1,2.558-5.828A.25.25,0,0,0,11.619,11.656Z', 'M22.769,18.6a1,1,0,0,0-1.27.622,4.091,4.091,0,0,1-6.918,1.42.25.25,0,0,1,.008-.345l1.722-1.722a.5.5,0,0,0-.354-.853H11.5a.5.5,0,0,0-.5.5V22.68a.5.5,0,0,0,.854.353l.969-.969a.251.251,0,0,1,.359,0,6.086,6.086,0,0,0,10.21-2.2A1,1,0,0,0,22.769,18.6Z', 'M23.692,11.773a.5.5,0,0,0-.545.108l-1.026,1.026a.252.252,0,0,1-.18.073.255.255,0,0,1-.178-.077,6.1,6.1,0,0,0-10.2,2.226,1,1,0,0,0,1.893.649,4.091,4.091,0,0,1,6.9-1.446.251.251,0,0,1-.007.347L18.69,16.338a.5.5,0,0,0,.353.854H23.5a.5.5,0,0,0,.5-.5V12.235A.5.5,0,0,0,23.692,11.773Z']],
  MonitorShare: ['monitor-share', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.9,15.735a.245.245,0,0,0-.014-.273.463.463,0,0,1-.094-.278v-.49a.49.49,0,0,1,.49-.49h1.206a.248.248,0,0,0,.111-.026,3.988,3.988,0,0,1,3.732,0,.236.236,0,0,0,.111.027h.227a1.93,1.93,0,0,0,.871-.21.246.246,0,0,0,.132-.252,2.037,2.037,0,0,1-.023-.273,4.114,4.114,0,0,1,.926-2.584.246.246,0,0,0,.054-.153V1.959A1.962,1.962,0,0,0,15.673,0H1.959A1.961,1.961,0,0,0,0,1.959V12.245A1.961,1.961,0,0,0,1.959,14.2H7.347a.49.49,0,0,1,.49.49v.49a.49.49,0,0,1-.49.489H4.9a.98.98,0,1,0,0,1.96H9.106a.244.244,0,0,0,.243-.219A4.118,4.118,0,0,1,9.9,15.735Zm-7.455-4.47a.489.489,0,0,1-.49-.489V2.449a.49.49,0,0,1,.49-.49H15.184a.489.489,0,0,1,.489.49v8.327a.489.489,0,0,1-.489.489Z', 'M24,20.816a3.169,3.169,0,0,0-5.507-2.154.245.245,0,0,1-.271.062L16.8,18.156a.245.245,0,0,1-.153-.24,2.534,2.534,0,0,0-.05-.588.246.246,0,0,1,.115-.256l1.872-1.123a.246.246,0,0,1,.278.018,3.142,3.142,0,0,0,1.951.686,3.184,3.184,0,1,0-3.183-3.184,3.008,3.008,0,0,0,.053.55.244.244,0,0,1-.115.255L15.7,15.4a.246.246,0,0,1-.278-.018,3.138,3.138,0,0,0-1.951-.686,3.184,3.184,0,0,0,0,6.367,3.154,3.154,0,0,0,2.323-1.029.246.246,0,0,1,.271-.062l1.417.567a.246.246,0,0,1,.154.244v.035a3.184,3.184,0,1,0,6.367,0Z']],
  MonitorCash: ['monitor-cash', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.1,11.915a.249.249,0,0,0-.188-.414H2.5A.5.5,0,0,1,2,11V2.5A.5.5,0,0,1,2.5,2h13a.5.5,0,0,1,.5.5V8.847a.25.25,0,0,0,.287.247A8.216,8.216,0,0,1,17.5,9c.079,0,.157,0,.235.008a.254.254,0,0,0,.187-.068A.25.25,0,0,0,18,8.759V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V12.5a2,2,0,0,0,2,2H7.5A.5.5,0,0,1,8,15v.5a.5.5,0,0,1-.5.5H5a1,1,0,0,0,0,2H8.758a.251.251,0,0,0,.25-.265C9,17.658,9,17.58,9,17.5A8.464,8.464,0,0,1,11.1,11.915Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm.95,10.2a.249.249,0,0,0-.2.245v.308a.75.75,0,1,1-1.5,0V21.5a.25.25,0,0,0-.25-.25H16a.75.75,0,0,1,0-1.5h2.033a.592.592,0,0,0,.221-1.141l-2.065-.826A2.085,2.085,0,0,1,16.55,13.8a.249.249,0,0,0,.2-.245v-.307a.75.75,0,1,1,1.5,0v.25a.25.25,0,0,0,.25.25H19a.75.75,0,0,1,0,1.5H16.967a.591.591,0,0,0-.221,1.14l2.065.826A2.085,2.085,0,0,1,18.45,21.2Z']]
};
exports["default"] = _default;